import React from 'react';
import { Tooltip } from 'antd';
import {
  ExclamationCircleFilled,
  InfoCircleOutlined,
  WarningFilled,
} from '@ant-design/icons';

function getInsightIcon(type) {
  switch (type) {
    case 'warning':
      return <WarningFilled className="configure-deployment-modal__insight-icon configure-deployment-modal__insight-icon--warning" />;
    case 'error':
      return <ExclamationCircleFilled className="configure-deployment-modal__insight-icon configure-deployment-modal__insight-icon--error" />;
    default:
      return <InfoCircleOutlined className="configure-deployment-modal__insight-icon configure-deployment-modal__insight-icon--info" />;
  }
}

/**
 * Single insight row — matches the Data Overview ``InsightsSection``
 * warning layout (status icon + text; explanation tooltip on the status icon).
 */
export default function InsightNotice({ content, explanation, type = 'warning' }) {
  const icon = getInsightIcon(type);
  return (
    <div className="configure-deployment-modal__insight-row">
      {explanation ? <Tooltip title={explanation}>{icon}</Tooltip> : icon}
      <div className="configure-deployment-modal__insight-text">{content}</div>
    </div>
  );
}
